export enum PermissionStatusEnum {
  NONE = 'NONE',
  VIEW = 'VIEW',
  VIEW_OR_EDIT = 'VIEW_OR_EDIT',
}

export const validPermissionStatuses = Object.values(PermissionStatusEnum);
